export enum RelationProjectState {
  Sandbox = 0,
  Proposed = 1,
  PendingLaunch = 2,
  Launched = 3,
  InterimSandbox = 4,
  InterimPending = 5,
  InterimLaunched = 6,
  LaunchedInactive = 7,
  InboundExpired = 8,
}

export const relationProjectStateAsString = new Map([
  [RelationProjectState.Sandbox, "Sandbox"],
  [RelationProjectState.Proposed, "Proposed"],
  [RelationProjectState.PendingLaunch, "Pending Launch"],
  [RelationProjectState.Launched, "Launched"],
  [RelationProjectState.InterimSandbox, "Interim Sandbox"],
  [RelationProjectState.InterimPending, "Interim Pending"],
  [RelationProjectState.InterimLaunched, "Interim Launched"],
  [RelationProjectState.LaunchedInactive, "Launched Inactive"],
  [RelationProjectState.InboundExpired, "Inbound Expired"],
]);
